/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager {
    angular.module("meevo.plugins.walkinManager", []);
}
